export function throttle<T extends (...args: unknown[]) => unknown>(
   func: T,
   wait: number,
   options: { trailing?: boolean } = {}
): (this: ThisParameterType<T>, ...args: Parameters<T>) => void {
   let lastTime = 0;
   let timeout: ReturnType<typeof setTimeout> | null = null;

   const trailing = options.trailing ?? true;

   return function (this: ThisParameterType<T>, ...args: Parameters<T>): void {
      const now = Date.now();
      const remaining = wait - (now - lastTime);
      const callNow = remaining <= 0;

      if (callNow) {
         if (timeout) {
            clearTimeout(timeout);
            timeout = null;
         }
         lastTime = now;
         func.apply(this, args);
      } else if (trailing && !timeout) {
         timeout = setTimeout(() => {
            timeout = null;
            lastTime = Date.now();
            func.apply(this, args);
         }, remaining);
      }
   };
}
